const query = (id, isPreview) => `
{
  multiRowTable(id: "${id}", preview: ${isPreview}){
    internalTitle
    heading
    itemId
    varient
    tableJsonData
    showHeading
    rowHeadingCollection{
      items{
      	title
        longTitle
        shortDescription
      }
    }
    rowCardsCollection(limit:65){
     items{
      rowCardHeadingAndDesc
      column1{
       ...on ImageWithText{
        heading
        mainHeading
        headingIsLink
        description
        buttonLink {
          label
          title
          url
          target
          scrollToElementId
          gaEventClass
          gaEventLabel
          image {
            title
            description
            url
            width
            height
          }
          
        }
        link {
          label
      title
      url
      target
      scrollToElementId
      gaEventClass
      gaEventLabel
      image {
        title
        description
        url
        width
        height
      }
      
        }
        categoryLinksCollection(limit:10) {
          items {
            name
             url
            label
            title
          }
        }
        variant
        images {
            altText
            imageDesktop{
              title
              url
              width
                height
            }
            imageMobile{
              title
              url
              width
                height
            }
        
          
          }
      }
        ... on SocialLink{
          label
          variant
          iconClass
        }
      }
      column2{
        ...on  ImageWithText{
        heading
        mainHeading
        headingIsLink
        description
        buttonLink {
          label
          title
          url
          target
          scrollToElementId
          gaEventClass
          gaEventLabel
          image {
            title
            description
            url
            width
            height
          }
          
        }
        categoryLinksCollection(limit:10) {
          items {
            name
             url
            label
            title
          }
        }
        variant
        images {
            altText
            imageDesktop{
              title
              url
              width
                height
            }
            imageMobile{
              title
              url
              width
                height
            }
        
           
          }
        }
          ... on SocialLink{
          label  
          variant
          iconClass
        }
      }
      column3{
        ...on  ImageWithText{
        heading
        mainHeading
        headingIsLink
        description
        buttonLink {
          label
          title
          url
          target
          scrollToElementId
          gaEventClass
          gaEventLabel
          image {
            title
            description
            url
            width
            height
          }
          
        }
        categoryLinksCollection(limit:10) {
          items {
            name
             url
            label
            title
          }
        }
        variant
        images {
            altText
            imageDesktop{
              title
              url
              width
                height
            }
            imageMobile{
              title
              url
              width
              height

            }
       
           
          }
        }
          ... on SocialLink{
          label
          variant  
          iconClass
        }
      }

      column4 {
        ... on ImageWithText {
          heading
          mainHeading
          headingIsLink
          description
          buttonLink {
            label
            title
            url
            target
            scrollToElementId
            gaEventClass
            gaEventLabel
            image {
              title
              description
              url
              width
              height
            }
            
          }
          categoryLinksCollection(limit: 10) {
            items {
              name
              url
              label
              title
            }
          }
          variant
          images {
            altText
            imageDesktop {
              title
              url
              width
                height
            }
            imageMobile {
              title
              url
              width
                height
            }
         
         
          }
        }
      }
      column5 {
        ... on ImageWithText {
          heading
          mainHeading
          headingIsLink
          description
          buttonLink {
            label
            title
            url
            target
            scrollToElementId
            gaEventClass
            gaEventLabel
            image {
              title
              description
              url
              width
              height
            }
            
          }
          categoryLinksCollection(limit: 10) {
            items {
              name
              url
              label
              title
            }
          }
          variant
          images {
            altText
            imageDesktop {
              title
              url
              width
                height
            }
            imageMobile {
              title
              url
              width
                height
            }
         
         
          }
        }
      }

      column6 {
        ... on ImageWithText {
          heading
          mainHeading
          description
          buttonLink {
            label
            title
            url
            target
            scrollToElementId
            gaEventClass
            gaEventLabel
            image {
              title
              description
              url
              width
              height
            }
            
          }
          categoryLinksCollection(limit: 10) {
            items {
              name
              url
              label
              title
            }
          }
          variant
          images {
            altText
            imageDesktop {
              title
              url
              width
                height
            }
          
          
           
          }
        }
      }

      column7 {
        ... on ImageWithText {
          heading
          mainHeading
          description
          buttonLink {
            label
            title
            url
            target
            scrollToElementId
            gaEventClass
            gaEventLabel
            image {
              title
              description
              url
              width
              height
            }
            
          }
          categoryLinksCollection(limit: 10) {
            items {
              name
              url
              label
              title
            }
          }
          variant
          images {
            altText
            imageDesktop {
              title
              url
              width
                height
            }
              imageMobile{
              title
              url
              width
                height
            }
            
         
       
          }
        }
      }
    }
    }
  }
}
`
module.exports = { query }
